import { Colors } from "../../../consts/Colors";
import FONTS from "../../../consts/Fonts";
import { tags } from "../../../consts/Tags";
import ButtonRounded from "../buttons/ButtonRounded";

export default class ReponsePopUp extends Phaser.GameObjects.Container {
    constructor(scene, x, y, {text, isTrue, isLast = false, endFunc}) {
        super(scene, x, y, []);

        this.soundManager = scene.soundManager
        this.isTrue = isTrue
        this.scene = scene;
        scene.add.existing(this);

        // Ajout titre
        let titre = this.scene.add.text(627, 32, isTrue ? "Bonne réponse !" : "Mauvaise réponse !", {
            fontFamily: FONTS.Inter28ExtraLight,
            fontSize: '102px',
            color: isTrue ? Colors.Text.GreenJardin : Colors.Text.Rose
        }).setOrigin(0)
        this.add(titre)

        // Ajout texte
        let textElmt = this.scene.add.rexTagText(titre.x, titre.y + titre.height + 16, text, {
            fontFamily: FONTS.Inter28SemiBold,
            fontSize: '40px',
            color: Colors.Text.White,
            wordWrap: { width: 1100 },
            tags: tags
        }).setOrigin(0)
        this.add(textElmt)

        // MAJ des positions
        // Ajout fond
        let background = this.scene.add.rectangle(0, 0, this.scene.width, textElmt.y + textElmt.height + 84, isTrue ? Colors.Elmt.Green : Colors.Elmt.Red, 0.9).setOrigin(0);
        background.setStrokeStyle(4, isTrue ? Colors.Elmt.GreenJardin : Colors.Elmt.Rose, 0.8)
        this.add(background)
        this.sendToBack(background)

        titre.y -= background.height/2
        textElmt.y -= background.height/2
        background.y -= background.height/2

        this.setSize(background.width, background.height);

        // Ajout bouton suivant
        let nextButton = new ButtonRounded(this.scene, 1216, background.height/2 - 8, {
            text: isLast ? "Continuer" : "Question suivante",
            color: Colors.Elmt.White,
            textColor: Colors.Text.Black,
            textHoverColor: Colors.Text.Blue,
            borderColor: Colors.Elmt.White,
            borderHoverColor: Colors.Elmt.Blue,
        })
        this.add(nextButton)
        nextButton.setClickFunction( () => {
            endFunc();
        })

    }

    animIn(){
        let audio = 'Good'
        if(!this.isTrue)
            audio = 'Wrong'
        this.soundManager.playOnce(audio)
        this.x -= this.scene.width
        this.scene.tweens.add({
            targets: this,
            x: 0,
            duration: 500,
        })
    }

    animOut(endFunc){
        this.scene.tweens.add({
            targets: this,
            x: -this.scene.width,
            duration: 500,
            onComplete: () => {
                this.destroy(true);
                if(endFunc)
                    endFunc();
            }
        })
    }
}